export default __webpack_public_path__ + "static/media/5.780352d6.jpg";